module.exports = __webpack_public_path__ + "static/media/App.54ffc3e8.scss";


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = 244
// module chunks = 0